import React, { Fragment } from "react";
import useGet from "../../hooks/useGet";
import Result from "./Result";
import Loading from "../Loading";

const NoFund = () => {
  return (
    <li className="QuickSearch-results-item QuickSearch-results-noFund f-scale-body">
      <a className="c-gray-dark" href="/disease-fund-availability">
        I do not see a fund for my disease
      </a>
    </li>
  );
};

// Normalize a permalink so keys match even if trailing slashes differ
function normalizePermalink(url) {
  var s = String(url || "");
  try {
    var a = document.createElement("a");
    a.href = s;
    var clean = a.protocol ? (a.protocol + "//" + a.host + a.pathname) : s;
    return clean.replace(/\/+$/, "");
  } catch (e) {
    return s.replace(/\/+$/, "");
  }
}

function lookupTitle(permalink, titlesMap) {
  if (!permalink || !titlesMap) return "";
  // try exact
  if (titlesMap[permalink]) return titlesMap[permalink];
  // try normalized (no trailing slash)
  const norm = normalizePermalink(permalink);
  if (titlesMap[norm]) return titlesMap[norm];
  // try with trailing slash
  if (titlesMap[norm + "/"]) return titlesMap[norm + "/"];
  // last-ditch: add slash to original if missing
  if (permalink.charAt(permalink.length - 1) !== "/" && titlesMap[permalink + "/"]) {
    return titlesMap[permalink + "/"];
  }
  return "";
}

const Results = (props) => {
  const { titlesMap = {} } = props;
  const [loading, response, error] = useGet(props.url, {
    params: props.params,
  });

  const funds = response && response.data && response.data.funds
    ? response.data.funds
    : [];

  return (
    <div className="QuickSearch-results" role="alert" aria-live="polite">
      {loading && <Loading className="Loading--small" label="Searching..." />}

      {funds.length !== 0 && (
        <Fragment>
          <p className="f-label c-purple">Select a Fund</p>
          <ol>
            {funds.map((result, i) => {
              const titleOverride =
                lookupTitle(result && result.permalink, titlesMap) ||
                result.Fund_Name ||
                result.Disease ||
                "";

              return (
                <Result
                  key={i}
                  result={result}
                  titleOverride={titleOverride}
                />
              );
            })}
            <NoFund />
          </ol>
        </Fragment>
      )}

      {funds.length === 0 && !loading && !error && (
        <ol>
          <li className="QuickSearch-results-item f-scale-body">
            Sorry, there are no medications or diseases associated with your
            search. We still may be able to help.{" "}
            <a href="/contact">Contact us</a>.
          </li>
        </ol>
      )}

      {error && (
        <ol>
          <li className="QuickSearch-results-item f-scale-body">
            {error.message}
          </li>
          <NoFund />
        </ol>
      )}
    </div>
  );
};

export default Results;
